module.exports = __webpack_public_path__ + "static/media/milk.32763ed7.jpg";